import { render, staticRenderFns } from "./SubjectReportListByStudentAndAchievement.vue?vue&type=template&id=4b62636b"
import script from "./SubjectReportListByStudentAndAchievement.vue?vue&type=script&lang=js"
export * from "./SubjectReportListByStudentAndAchievement.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports